import React from 'react';

const STATUS_CONFIG = {
  active: { label: 'Active', className: 'survey-pill-active' },
  ended: { label: 'Ended', className: 'survey-pill-ended' },
  completed: { label: 'Completed', className: 'survey-pill-active' },
  pending: { label: 'Pending', className: 'survey-pill-pending' },
};

const SurveyStatusPill = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.active;

  return (
    <span className={`survey-pill ${config.className}`}>
      <span className="survey-pill-dot"></span>
      {config.label}
    </span>
  );
};

export default SurveyStatusPill;
